const mapping = {
    // special keys
    // mitgliedschaft_mitgliedschaft_mitgliedschaft: '',
    vorsorge_pav_ausreichendesvermoegen: 'AR_4_Vorsorge_AusreichendVermoegen',
    immobilie_finanzierung_abgezahlteimmobilie: 'AR_5_Immobilie_AbgezahlteImmobilie',
    // standard products
    liquiditaet_girokonto_vrkomplett: 'AR_1_Liquiditaet_Girokonto_VRKomplett',
    liquiditaet_girokonto_vrdirekt: 'AR_1_Liquiditaet_Girokonto_VRDirekt',
    liquiditaet_girokonto_vrdirektlight: 'AR_1_Liquiditaet_Girokonto_VRDirektlight',
    liquiditaet_girokonto_vrindividual: 'AR_1_Liquiditaet_Girokonto_VRIndividual',
    liquiditaet_girokonto_vrmeinkonto: 'AR_1_Liquiditaet_Girokonto_VRMeinKonto',
    liquiditaet_girokonto_mitarbeiterkonto: 'AR_1_Liquiditaet_Girokonto_Mitarbeiterkonto',
    liquiditaet_girokonto_privatplus: 'AR_1_Liquiditaet_Girokonto_PrivatPLUS',
    liquiditaet_kreditkarteeasycredit_goldcard: 'AR_1_Liquiditaet_KreditkarteeasyCredit_GoldCard',
    liquiditaet_kreditkarteeasycredit_classiccard: 'AR_1_Liquiditaet_KreditkarteeasyCredit_ClassicCard',
    liquiditaet_kreditkarteeasycredit_easycredit: 'AR_1_Liquiditaet_KreditkarteeasyCredit_easyCredit',
    liquiditaet_bankingapp_bankingapp: 'AR_1_Liquiditaet_BankingApp_BankingApp',
    absicherung_sachversicherung_haftpflichtversicherung: 'AR_2_Absicherung_Sachversicherung_Haftpflichtversicherung',
    absicherung_sachversicherung_kfzversicherung: 'AR_2_Absicherung_Sachversicherung_KFZVersicherung',
    absicherung_sachversicherung_wohngebaeudeversicherung: 'AR_2_Absicherung_Sachversicherung_Wohngebaeudeversicherung',
    absicherung_sachversicherung_hausratversicherung: 'AR_2_Absicherung_Sachversicherung_Hausratversicherung',
    absicherung_sachversicherung_rechtsschutzversicherung: 'AR_2_Absicherung_Sachversicherung_Rechtsschutzversicherung',
    absicherung_sachversicherung_tierversicherung: 'AR_2_Absicherung_Sachversicherung_Tierversicherung',
    absicherung_einkommensversicherung_berufsunfaehigkeitsversicherung:
        'AR_2_Absicherung_Einkommensversicherung_Berufsunfaehigkeitsversicherung',
    absicherung_einkommensversicherung_risikolebensversicherung:
        'AR_2_Absicherung_Einkommensversicherung_Risikolebensversicherung',
    absicherung_einkommensversicherung_unfallversicherung: 'AR_2_Absicherung_Einkommensversicherung_Unfallversicherung',
    absicherung_einkommensversicherung_kreditversicherung: 'AR_2_Absicherung_Einkommensversicherung_Kreditversicherung',
    absicherung_einkommensversicherung_kontoschutzpolice: 'AR_2_Absicherung_Einkommensversicherung_Kontoschutzpolice',
    absicherung_krankenversicherung_krankenzusatzversicherung:
        'AR_2_Absicherung_Krankenversicherung_Krankenzusatzversicherung',
    absicherung_krankenversicherung_krankenvollversicherung:
        'AR_2_Absicherung_Krankenversicherung_Krankenvollversicherung',
    vermoegen_bankeinlagen_finanzpuffer: 'AR_3_Vermoegen_Bankeinlagen_Finanzpuffer',
    vermoegen_sparplan_fondssparplan: 'AR_3_Vermoegen_Sparplan_Fondssparplan',
    vermoegen_sparplan_meininvest: 'AR_3_Vermoegen_Sparplan_MeinInvest',
    vermoegen_sparplan_vermoegenplus: 'AR_3_Vermoegen_Sparplan_VermoegenPlus',
    vermoegen_depot_bankdepot: 'AR_3_Vermoegen_Depot_Bankdepot',
    vermoegen_depot_uniondepot: 'AR_3_Vermoegen_Depot_UnionDepot',
    vermoegen_depot_meininvest: 'AR_3_Vermoegen_Depot_MeinInvest',
    vermoegen_depot_vermoegenplus: 'AR_3_Vermoegen_Depot_VermoegenPlus',
    vorsorge_bausparvertrag_bausparvertrag: 'AR_4_Vorsorge_Bausparvertrag_Bausparvertrag',
    vorsorge_staatlichbav_riesterruerup: 'AR_4_Vorsorge_StaatlichbAV_RiesterRuerup',
    vorsorge_staatlichbav_betrieblichealtersvorsorge: 'AR_4_Vorsorge_StaatlichbAV_BetrieblicheAltersvorsorge',
    vorsorge_pav_kapitallebensversicherung: 'AR_4_Vorsorge_pAV_Kapitallebensversicherung',
    immobilie_finanzierung_baufinanzierung: 'AR_5_Immobilie_Finanzierung_Baufinanzierung',
    extra_kontoauszug_elektronischerkontoauszug: 'AR_6_Extra_Kontoauszug_elektronischerKontoauszug',
    extra_depot_depotvolumen1: 'AR_6_Extra_Depot_Depotvolumen1',
    extra_depot_depotvolumen2: 'AR_6_Extra_Depot_Depotvolumen2',
    extra_depot_depotvolumen3: 'AR_6_Extra_Depot_Depotvolumen3',
    extra_depot_depotvolumen4: 'AR_6_Extra_Depot_Depotvolumen4',
    extra_depot_depotvolumen5: 'AR_6_Extra_Depot_Depotvolumen5',
    extra_jugendvorteil_jugendvorteil1: 'AR_6_Extra_Jugendvorteil_Jugendvorteil1',
    extra_jugendvorteil_jugendvorteil2: 'AR_6_Extra_Jugendvorteil_Jugendvorteil2',
    extra_neukunde_neukunde: 'AR_6_Extra_Neukunde_Neukunde',
};

export default function mapper(productId) {
    if (!mapping.hasOwnProperty(productId)) {
        console.log(`${productId} not found in mapping`);
        // return given productId of not found in mapping!
        return productId;
    }

    return mapping[productId];
}

export function reverseMapper(appId) {
    if (!JSON.stringify(mapping).includes(appId)) {
        console.log(`${appId} not found in reverse-mapping`);
        console.trace();
        return null;
    }
    return Object.keys(mapping).find((key) => mapping[key] === appId);
}
